import CheckIcon from '@mui/icons-material/Check';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Stack from '@mui/material/Stack';
import moment from 'moment';
import { graphql, useFragment } from 'react-relay';

import { useTheme } from '@woovi/hooks';
import { SUBSCRIPTION_INSTALLMENT_STATUS_ENUM } from '@woovi/shared';
import { PaymentLinkRow } from '@woovi/ui';

import type { PaymentInstallmentRow_paymentSubscriptionInstallment$key } from './__generated__/PaymentInstallmentRow_paymentSubscriptionInstallment.graphql.ts';

import type { ReactNode } from 'react';

type PaymentInstallmentRowProps = {
  paymentSubscriptionInstallment: PaymentInstallmentRow_paymentSubscriptionInstallment$key;
};
const PaymentInstallmentRow = (
  props: PaymentInstallmentRowProps,
): ReactNode => {
  const theme = useTheme();
  const paymentSubscriptionInstallment =
    useFragment<PaymentInstallmentRow_paymentSubscriptionInstallment$key>(
      graphql`
        fragment PaymentInstallmentRow_paymentSubscriptionInstallment on PaymentSubscriptionInstallment {
          status
          installmentNumber
          value
          dateGenerateCharge
        }
      `,
      props.paymentSubscriptionInstallment,
    );

  const { installmentNumber, dateGenerateCharge, value, status } =
    paymentSubscriptionInstallment;

  const renderTitle = (): ReactNode => {
    const dateGenerateChargeFormat =
      moment(dateGenerateCharge).format('DD/MM/YYYY');

    if (status === SUBSCRIPTION_INSTALLMENT_STATUS_ENUM.ACTIVE) {
      return (
        <Stack direction={'row'} sx={{ alignItems: 'center' }}>
          <Stack
            direction={'row'}
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
              width: '28px',
              height: '28px',
              flex: 'none',
              color: theme.button.textColor,
              borderRadius: '50%',
              background: theme.palette.warning.main,
              mr: '5px',
            }}
          >
            <MoreHorizIcon />
          </Stack>
          {dateGenerateChargeFormat}
        </Stack>
      );
    }

    if (status === SUBSCRIPTION_INSTALLMENT_STATUS_ENUM.COMPLETED) {
      return (
        <Stack direction={'row'} sx={{ alignItems: 'center' }}>
          <Stack
            direction={'row'}
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
              width: '28px',
              height: '28px',
              flex: 'none',
              color: theme.button.textColor,
              borderRadius: '50%',
              background: theme.palette.primary.main,
              mr: '5px',
            }}
          >
            <CheckIcon />
          </Stack>
          {dateGenerateChargeFormat}
        </Stack>
      );
    }

    return (
      <Stack direction={'row'} sx={{ alignItems: 'center' }}>
        <Stack
          direction={'row'}
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
            width: '28px',
            height: '28px',
            flex: 'none',
            color: theme.button.textColor,
            borderRadius: '50%',
            background: theme.palette.secondary.light,
            mr: '5px',
          }}
        >
          {installmentNumber}º
        </Stack>
        {dateGenerateChargeFormat}
      </Stack>
    );
  };

  return <PaymentLinkRow title={renderTitle()} value={value} />;
};

export default PaymentInstallmentRow;
